import * as real from "src/auth/auth.service"
import * as mock from "src/auth/auth.mock"
import { queryOptions } from "@tanstack/react-query"
import { selectService } from "@myvp/shared/src/functions/mock"

const service =
  process.env.REACT_APP_release === "true"
    ? real
    : selectService({ mock, real })
export const getVaultUserMetadataQueryOptions = (args: { vaultId: string }) => {
  return queryOptions({
    queryKey: ["getVaultUserInfo", args.vaultId],
    queryFn: async () => {
      const metadata = await service.getVaultUserMetadata()

      if (metadata.userTimezone && metadata.userLocale) {
        return {
          userTimezone: metadata.userTimezone,
          // Remove this when we start translating sponsor study home
          userLocale: "en-US",
        }
      } else {
        const userInfo = await service.getVaultUserInfo()
        let result = {
          ...userInfo,
          // Remove this when we start translating sponsor study home
          userLocale: "en-US",
        }
        service.setVaultUserMetadata(result)
        return result
      }
    },
    gcTime: Infinity,
    staleTime: Infinity,
  })
}

export const isValidVaultSessionQueryOptions = (args: { vaultId: string }) =>
  queryOptions({
    queryKey: ["isValidVaultSession", args.vaultId],
    queryFn: service.isValidVaultSession,
    refetchOnWindowFocus: "always",
  })

export const getVaultDnsQuery = (args: { vaultId: string }) =>
  queryOptions({
    queryKey: ["getVaultDns", args.vaultId],
    queryFn: () => {
      return service.getVaultDns({ vaultId: args.vaultId })
    },
  })

export const embeddedLogin = (
  args: Parameters<typeof service.embeddedLogin>[0]
) => service.embeddedLogin(args)
